import { render } from "./AddressPicker.vue?vue&type=template&id=a552d5ae&scoped=true"
import script from "./AddressPicker.vue?vue&type=script&lang=js"
export * from "./AddressPicker.vue?vue&type=script&lang=js"

import "./AddressPicker.vue?vue&type=style&index=0&id=a552d5ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a552d5ae"]])

export default __exports__